export default "__VITE_PUBLIC_ASSET__7f26a134__"